<div class="modal">

  <div class="modal-container modal-container--scroll">
      <div class="bgr" (click)="close.emit()"></div>
      <ng-content></ng-content>
  </div>
</div>
